import checkbox from '@form-create/component-elm-checkbox/src/index';
import frame from '@form-create/component-elm-frame/src/index';
import radio from '@form-create/component-elm-radio/src/index';
import select from '@form-create/component-elm-select/src/index';
import tree from '@form-create/component-elm-tree/src/index';
import upload from '@form-create/component-elm-upload/src/index';
import group from '@form-create/component-elm-group/src/index';
import subForm from '@form-create/component-subform/src/index';


export default [
    checkbox,
    frame,
    radio,
    select,
    tree,
    upload,
    group,
    subForm,
]
